import { focusRing } from './focusRing'
import { navLink } from './navLink'

export const layerStyles = {
  navLink,
  focusRing,
}
